import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCopilotOrigin } from "@/lib/navigation";

// RC50 V5-D NAV-009: visible, recoverable navigation failure — never a silent redirect,
// never a leak of whether an unauthorized record exists, never internal error details.
const MESSAGES = {
  unavailable: "This record isn't available to you or no longer exists.",
  invalid: "That navigation target isn't valid.",
  error: "The record could not be loaded right now. Nothing was changed.",
};

export function reasonFromError(e) {
  const s = e?.response?.status;
  if (s === 404 || s === 403 || s === 401) return "unavailable";
  if (s === 400 || s === 422) return "invalid";
  return "error";
}

export function NavigationFailure({ reason = "unavailable", moduleLabel, modulePath }) {
  const { fromCopilot, back } = useCopilotOrigin();
  return (
    <div className="mx-auto mt-16 max-w-md rounded-md border border-border bg-white p-8 text-center" data-testid="navigation-failure" data-reason={reason}>
      <AlertTriangle className="mx-auto h-6 w-6 text-terracotta" />
      <p className="mt-3 text-sm text-charcoal" data-testid="navigation-failure-message">{MESSAGES[reason] || MESSAGES.error}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        <Button asChild variant="outline" className="border-limestone text-charcoal hover:bg-sand">
          <Link to={modulePath} data-testid="navigation-failure-module">Back to {moduleLabel}</Link>
        </Button>
        {fromCopilot && (
          <Button onClick={back} className="bg-terracotta text-white hover:bg-terracotta-hover" data-testid="navigation-failure-copilot">Back to Copilot</Button>
        )}
      </div>
    </div>
  );
}
